<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core";
import type { ContentGridDynamicFilters, ArticleCategory } from "./ContentGridDynamicTypes";

const emit = defineEmits(["categoryChanged", "subcategoryChanged", "termChanged", "update:term"]);
const term = defineModel<string>("term");

function createDropdownOption(category: ArticleCategory) {
	return {
		label: `${category.key} (${category.doc_count})`,
		value: category.key,
	};
}

const props = defineProps<ContentGridDynamicFilters>();

const searchLabel = computed(() => {
	if (props.selectedSubcategory || props.selectedCategory)
		return `Søk i ${props.selectedSubcategory || props.selectedCategory}`;
	return "Søk";
});

const subcategoryLabel = computed(() => {
	if (categoryOptions.value.length > 1) return "Alle underkategorier";
	return "Alle kategorier";
});

const categoryOptions = computed(() => {
	return [{ label: "Alle kategorier", value: "" }, ...props.categoryOptions.map(createDropdownOption)];
});

const subcategoryOptions = computed(() => {
	return [{ label: subcategoryLabel.value, value: "" }, ...props.subcategoryOptions.map(createDropdownOption)];
});

const handleTermChange = useDebounceFn((value) => {
	emit("update:term", value);
}, 300);
</script>

<template>
	<div class="grid-columns-4 margin-bottom-xl">
		<TnDropdownSelect
			v-if="categoryOptions.length > 2"
			:options="categoryOptions"
			placeholder="Alle kategorier"
			:modelValue="selectedCategory"
			@update:modelValue="$emit('categoryChanged', $event)"
		/>
		<TnDropdownSelect
			:options="subcategoryOptions"
			:placeholder="subcategoryLabel"
			:modelValue="selectedSubcategory"
			@update:modelValue="$emit('subcategoryChanged', $event)"
			clearable
		/>
		<TnTextField
			:placeholder="searchLabel"
			:modelValue="term"
			@update:modelValue="handleTermChange"
			size="m"
			icon-left="search"
			clearable
		/>
	</div>
</template>

<style scoped lang="scss"></style>
